import React from "react";
import './style.css'
 
const TermsAndCondition = ({src}: any) => {
  return (
    <div className="terms_wrapper">
      <img src={src} alt="terms-and-conditions" />
    </div>
  );
};

export default TermsAndCondition;
